import { Ref, useEffect, useRef, useState } from "@lukekaalim/act";
import { PhysicsDice, PhysicsDiceID, TheatreMatrix4 } from "../defs";

import JoltNamespace from 'jolt-physics/wasm-compat';
import * as three from 'three';


import { createBeat, useAsync, useJeffect, useLogger } from "@kosmod/kit";
import { TheatreState } from "./useTheatreState";
import { K3D, Snap } from "@kosmod/graphics-3d";

export const physicsBeat = createBeat();

export const usePhysics = (
  // diceToSimulate: PhysicsDice[],
  // state: TheatreState
) => {
  const tick = physicsBeat.useTick();

  const { result: physicsEngine } = useAsync(() => Snap.Engine.Load(), []);

  const [physicsSim, setPhysicsSim] = useState<null | Snap.Simulation>(null);

  const logger = useLogger('TheatrePhysics');

  const diceMap = useRef(new Map<PhysicsDiceID, K3D.Transform>()).get();

  useJeffect((j) => {
    if (!physicsEngine)
      return;

    const sim = physicsEngine.createSimulation();
    setPhysicsSim(sim);

    logger.log(`Sim Ready`)

    const intervalId = setInterval(() => {
      sim.tick();
      tick(performance.now());
    }, 1000 / 30)

    j.add(() => {
      clearInterval(intervalId);
      setPhysicsSim(null);
      sim.dispose();
    })
  }, [physicsEngine])

  return [physicsSim, diceMap] as const;
};